import React from 'react'
import SimpleStepNav from '../navigation/SimpleStepNav'
import InputRadioBox from '../inputs/InputRadioBox'
import InputWrapper from '../inputs/InputWrapper'
import WhenCondition from '../misc/WhenCondition'
import FormHeader from '../inputs/FormHeader'
import useNavigationManager from '../hooks/use-navigation-manager'
import useSettingsManager from '../hooks/use-settings-manager'
import InputExtraProducts from '../inputs/extra-products/InputExtraProducts'

function ExtrasStep () {
  const nav_manager = useNavigationManager()
  const settings_manager = useSettingsManager()
  const step_index = 1
  const step_name = nav_manager.getStepName(step_index)
  const strings = settings_manager.getStepSettings(step_name)

  return (
    <React.Fragment>
      <FormHeader htag={'h1'} strings={strings}/>

      <InputWrapper name={'door'}>
        <InputRadioBox value={'none'} size={'half'}/>
        <WhenCondition condition={'doorAllowedSide'}>
          <InputRadioBox name={'door'} value={'left'} size={'half'}/>
        </WhenCondition>
        <WhenCondition condition={'doorAllowedCenter'}>
          <InputRadioBox name={'door'} value={'center'} size={'half'}/>
        </WhenCondition>
        <WhenCondition condition={'doorAllowedSide'}>
          <InputRadioBox name={'door'} value={'right'} size={'half'}/>
        </WhenCondition>
      </InputWrapper>

      <WhenCondition condition={'hasDoor'}>
        <InputWrapper name={'door_direction'}>
          <InputRadioBox value={'left_out'} image={true} size={'half'} updatesPrice={false}/>
          <InputRadioBox value={'right_out'} image={true} size={'half'} updatesPrice={false}/>
        </InputWrapper>

        <InputWrapper name={'steps'}>
          <InputRadioBox value={'standard'} image={true} size={'half'}/>
          <InputRadioBox value={'low'} image={true} size={'half'}/>
        </InputWrapper>
      </WhenCondition>

      <InputWrapper name={'motor'}>
        <InputRadioBox value={'no'} size={'half'}/>
        <InputRadioBox value={'yes'} size={'half'}/>
      </InputWrapper>

      <WhenCondition condition={'hasMotor'}>
        <InputWrapper name={'extra_products'}>
          <InputExtraProducts/>
        </InputWrapper>
      </WhenCondition>

      <SimpleStepNav step_name={step_name}/>
    </React.Fragment>
  )
}

export default ExtrasStep